import "../css/index.css";
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";
import carousel from "./carousel";
import newsletter, { share, archiveFilters, contactForm, unsubscribeForm, franchiseViews, searchPage, motionPage, homeMotion, syncMotionNav, applyLeafLabels, bindMotionVideoModal } from "./ui";

menuOpen();
carousel();
newsletter();
share();
applyLeafLabels();
archiveFilters();
contactForm();
unsubscribeForm();
franchiseViews();
searchPage();
motionPage();
syncMotionNav();
homeMotion();
bindMotionVideoModal();

if (document.querySelector('.taohs-feed.gh-postfeed')) {
    infiniteScroll();
}
